export const handleFormatValueInput = (
  newValue: string,
  currentValue: string,
): string => {
  // Sanitiza entrada — apenas números, vírgula e ponto
  let sanitizedValue = newValue.replace(/[^0-9,.]/g, '');
  sanitizedValue = sanitizedValue.replaceAll('.', '').replaceAll(',', '.');

  const numericValue = parseFloat(sanitizedValue);
  let formattedValue = '0,00';

  // Caso o usuário esteja apagando caracteres
  if (currentValue.length > sanitizedValue.length) {
    if (!isNaN(numericValue) && numericValue > 0) {
      formattedValue = (numericValue / 10).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    }
  }
  // Caso esteja digitando
  else if (!isNaN(numericValue)) {
    const [integerValue, decimalValue] = sanitizedValue.split('.');
    let valueToFormat = numericValue;

    if (parseFloat(integerValue) === 0) {
      valueToFormat = parseFloat(sanitizedValue) * 10;
    } else if (decimalValue && decimalValue.length > 2) {
      valueToFormat = parseFloat(sanitizedValue) * 10;
    }

    formattedValue = valueToFormat.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  // Garantia de fallback
  if (
    isNaN(numericValue) ||
    !sanitizedValue ||
    typeof sanitizedValue === 'undefined'
  ) {
    formattedValue = (0).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
    });
  }

  return formattedValue;
};
